import * as React from "react";
import Typography from "@mui/material/Typography";
import ForwardIcon from "@mui/icons-material/Forward";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { Box } from "@mui/material";

export default function ShortCutsList() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-evenly",
        border: "double 3px",
        p: 1,
        borderRadius: 3,
        flexWrap: "wrap",
        flexDirection: "row-reverse",
      }}
    >
      <Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            border: "dashed 1px",
            p: 0.5,
            justifyContent: "space-between",
            m: 0.5,
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              px: 0.5,
              // backgroundColor: "white",
              // color: "#000000",
              borderRadius: 1,
              mx: 0.5,
              borderStyle: "outset",
              fontSize: "13px",
            }}
          >
            <ArrowUpwardIcon fontSize="small" />
          </Typography>
          <ForwardIcon fontSize="small" />
          <Typography sx={{ fontSize: "13px" }}>Volume Up</Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            border: "dashed 1px",
            p: 0.5,
            justifyContent: "space-between",
            m: 0.5,
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              px: 0.5,
              // backgroundColor: "white",
              // color: "#000000",
              borderRadius: 1,
              mx: 0.5,
              borderStyle: "outset",
              fontSize: "13px",
            }}
          >
            <ArrowDownwardIcon fontSize="small" />
          </Typography>
          <ForwardIcon fontSize="small" />
          <Typography sx={{ fontSize: "13px" }}>Volume Down</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            border: "dashed 1px",
            p: 0.5,
            justifyContent: "space-between",
            m: 0.5,
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              px: 0.5,
              // backgroundColor: "white",
              // color: "#000000",
              borderRadius: 1,
              mx: 0.5,
              borderStyle: "outset",
              fontSize: "13px",
            }}
          >
            <ArrowRightAltIcon fontSize="small" />
          </Typography>
          <ForwardIcon fontSize="small" />
          <Typography sx={{ fontSize: "13px" }}>Forward</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            border: "dashed 1px",
            p: 0.5,
            justifyContent: "space-between",
            m: 0.5,
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              px: 0.5,
              // backgroundColor: "white",
              // color: "#000000",
              borderRadius: 1,
              mx: 0.5,
              borderStyle: "outset",
              fontSize: "13px",
            }}
          >
            <ArrowDownwardIcon fontSize="small" />
          </Typography>
          <ForwardIcon fontSize="small" />
          <Typography sx={{ fontSize: "13px" }}>Rewind</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            border: "dashed 1px",
            p: 0.5,
            justifyContent: "space-between",
            m: 0.5,
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              px: 0.5,
              // backgroundColor: "white",
              // color: "#000000",
              borderRadius: 1,
              mx: 0.5,
              borderStyle: "outset",
              fontSize: "15px",
            }}
          >
            L
          </Typography>
          <ForwardIcon fontSize="small" />
          <Typography sx={{ fontSize: "13px" }}>Forward(5 sec)</Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            border: "dashed 1px",
            p: 0.5,
            justifyContent: "space-between",
            m: 0.5,
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              px: 0.5,
              // backgroundColor: "white",
              // color: "#000000",
              borderRadius: 1,
              mx: 0.5,
              borderStyle: "outset",
              fontSize: "15px",
            }}
          >
            J
          </Typography>
          <ForwardIcon fontSize="small" />
          <Typography sx={{ fontSize: "13px" }}>Rewind(5 sec)</Typography>
        </Box>
      </Box>
      <Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            border: "dashed 1px",
            p: 0.5,
            justifyContent: "space-between",
            m: 0.5,
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              px: 0.5,
              // backgroundColor: "white",
              // color: "#000000",
              borderRadius: 1,
              mx: 0.5,
              borderStyle: "outset",
              fontSize: "13px",
            }}
          >
            M
          </Typography>
          <ForwardIcon fontSize="small" />
          <Typography sx={{ fontSize: "13px" }}>Mute</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            border: "dashed 1px",
            p: 0.5,
            justifyContent: "space-between",
            m: 0.5,
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              px: 0.5,
              // backgroundColor: "white",
              // color: "#000000",
              borderRadius: 1,
              mx: 0.5,
              borderStyle: "outset",
              fontSize: "13px",
            }}
          >
            K
          </Typography>
          <ForwardIcon fontSize="small" />
          <Typography sx={{ fontSize: "13px" }}>Play/Pause</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            border: "dashed 1px",
            p: 0.5,
            justifyContent: "space-between",
            m: 0.5,
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              px: 0.5,
              // backgroundColor: "white",
              // color: "#000000",
              borderRadius: 1,
              mx: 0.5,
              borderStyle: "outset",
              fontSize: "13px",
            }}
          >
            Space
          </Typography>
          <ForwardIcon fontSize="small" />
          <Typography sx={{ fontSize: "13px" }}>Play/Pause</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            border: "dashed 1px",
            p: 0.5,
            justifyContent: "space-between",
            m: 0.5,
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              px: 0.5,
              // backgroundColor: "white",
              // color: "#000000",
              borderRadius: 1,
              mx: 0.5,
              borderStyle: "outset",
              fontSize: "13px",
            }}
          >
            Enter
          </Typography>
          <ForwardIcon fontSize="small" />
          <Typography sx={{ fontSize: "13px" }}>FullScreen</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            border: "dashed 1px",
            p: 0.5,
            justifyContent: "space-between",
            m: 0.5,
            alignItems: "center",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "row-reverse" }}>
            <Typography
              sx={{
                px: 0.5,
                // backgroundColor: "white",
                // color: "#000000",
                borderRadius: 1,
                mx: 0.5,
                borderStyle: "outset",
                fontSize: "13px",
              }}
            >
              Shift
            </Typography>
            <Typography>+</Typography>
            <Typography
              sx={{
                px: 0.5,
                // backgroundColor: "white",
                // color: "#000000",
                borderRadius: 1,
                mx: 0.5,
                borderStyle: "outset",
                fontSize: "13px",
              }}
            >
              -
            </Typography>
          </Box>
          <ForwardIcon fontSize="small" />

          <Typography sx={{ fontSize: "13px" }}>Decreace Rate</Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            border: "dashed 1px",
            p: 0.5,
            justifyContent: "space-between",
            m: 0.5,
            alignItems: "center",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "row-reverse" }}>
            <Typography
              sx={{
                px: 0.5,
                // backgroundColor: "white",
                // color: "#000000",
                borderRadius: 1,
                mx: 0.5,
                borderStyle: "outset",
                fontSize: "13px",
              }}
            >
              Shift
            </Typography>
            <Typography>+</Typography>
            <Typography
              sx={{
                px: 0.5,
                // backgroundColor: "white",
                // color: "#000000",
                borderRadius: 1,
                mx: 0.5,
                borderStyle: "outset",
                fontSize: "13px",
              }}
            >
              +
            </Typography>
          </Box>
          <ForwardIcon fontSize="small" />

          <Typography sx={{ fontSize: "13px" }}>Increace Rate</Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            border: "dashed 1px",
            p: 0.5,
            justifyContent: "space-between",
            m: 0.5,
            alignItems: "center",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "row-reverse" }}>
            <Typography
              sx={{
                px: 0.5,
                // backgroundColor: "white",
                // color: "#000000",
                borderRadius: 1,
                mx: 0.5,
                borderStyle: "outset",
                fontSize: "13px",
              }}
            >
              Shift
            </Typography>
            <Typography>+</Typography>
            <Typography
              sx={{
                px: 0.5,
                // backgroundColor: "white",
                // color: "#000000",
                borderRadius: 1,
                mx: 0.5,
                borderStyle: "outset",
                fontSize: "13px",
              }}
            >
              *
            </Typography>
          </Box>
          <ForwardIcon fontSize="small" />

          <Typography sx={{ fontSize: "13px" }}>Reset Rate</Typography>
        </Box>
      </Box>
      <Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            border: "dashed 1px",
            p: 0.5,
            justifyContent: "space-between",
            m: 0.5,
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              px: 0.5,
              // backgroundColor: "white",
              // color: "#000000",
              borderRadius: 1,
              mx: 0.5,
              borderStyle: "outset",
              fontSize: "13px",
            }}
          >
            A
          </Typography>
          <ForwardIcon fontSize="small" />
          <Typography sx={{ fontSize: "13px" }}>Previous subtitle</Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            border: "dashed 1px",
            p: 0.5,
            justifyContent: "space-between",
            m: 0.5,
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              px: 0.5,
              // backgroundColor: "white",
              // color: "#000000",
              borderRadius: 1,
              mx: 0.5,
              borderStyle: "outset",
              fontSize: "13px",
            }}
          >
            S
          </Typography>
          <ForwardIcon fontSize="small" />
          <Typography sx={{ fontSize: "13px" }}>Repeat subtitle</Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            border: "dashed 1px",
            p: 0.5,
            justifyContent: "space-between",
            m: 0.5,
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              px: 0.5,
              // backgroundColor: "white",
              // color: "#000000",
              borderRadius: 1,
              mx: 0.5,
              borderStyle: "outset",
              fontSize: "13px",
            }}
          >
            D
          </Typography>
          <ForwardIcon fontSize="small" />
          <Typography sx={{ fontSize: "13px" }}>Next subtitle</Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            border: "dashed 1px",
            p: 0.5,
            justifyContent: "space-between",
            m: 0.5,
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              px: 0.5,
              // backgroundColor: "white",
              // color: "#000000",
              borderRadius: 1,
              mx: 0.5,
              borderStyle: "outset",
              fontSize: "13px",
            }}
          >
            F
          </Typography>
          <ForwardIcon fontSize="small" />
          <Typography sx={{ fontSize: "13px" }}>
            Unlimited repetition
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            border: "dashed 1px",
            p: 0.5,
            justifyContent: "space-between",
            m: 0.5,
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              px: 0.5,
              // backgroundColor: "white",
              // color: "#000000",
              borderRadius: 1,
              mx: 0.5,
              borderStyle: "outset",
              fontSize: "13px",
            }}
          >
            Q
          </Typography>
          <ForwardIcon fontSize="small" />
          <Typography sx={{ fontSize: "13px" }}>
            Increase FontSize (1)
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            border: "dashed 1px",
            p: 0.5,
            justifyContent: "space-between",
            m: 0.5,
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              px: 0.5,
              // backgroundColor: "white",
              // color: "#000000",
              borderRadius: 1,
              mx: 0.5,
              borderStyle: "outset",
              fontSize: "13px",
            }}
          >
            W
          </Typography>
          <ForwardIcon fontSize="small" />
          <Typography sx={{ fontSize: "13px" }}>Reduce FontSize (1)</Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            border: "dashed 1px",
            p: 0.5,
            justifyContent: "space-between",
            m: 0.5,
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              px: 0.5,
              // backgroundColor: "white",
              // color: "#000000",
              borderRadius: 1,
              mx: 0.5,
              borderStyle: "outset",
              fontSize: "13px",
            }}
          >
            E
          </Typography>
          <ForwardIcon fontSize="small" />
          <Typography sx={{ fontSize: "13px" }}>
            Increase FontSize (2)
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            border: "dashed 1px",
            p: 0.5,
            justifyContent: "space-between",
            m: 0.5,
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              px: 0.5,
              // backgroundColor: "white",
              // color: "#000000",
              borderRadius: 1,
              mx: 0.5,
              borderStyle: "outset",
              fontSize: "13px",
            }}
          >
            R
          </Typography>
          <ForwardIcon fontSize="small" />
          <Typography sx={{ fontSize: "13px" }}>Reduce FontSize (2)</Typography>
        </Box>
      </Box>

      <Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            border: "dashed 1px",
            p: 0.5,
            justifyContent: "space-between",
            m: 0.5,
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              px: 0.5,
              // backgroundColor: "white",
              // color: "#000000",
              borderRadius: 1,
              mx: 0.5,
              borderStyle: "outset",
              fontSize: "13px",
            }}
          >
            Z
          </Typography>
          <ForwardIcon fontSize="small" />
          <Typography sx={{ fontSize: "13px" }}>Subtitle SideBar</Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            border: "dashed 1px",
            p: 0.5,
            justifyContent: "space-between",
            m: 0.5,
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              px: 0.5,
              // backgroundColor: "white",
              // color: "#000000",
              borderRadius: 1,
              mx: 0.5,
              borderStyle: "outset",
              fontSize: "13px",
            }}
          >
            T
          </Typography>
          <ForwardIcon fontSize="small" />
          <Typography sx={{ fontSize: "13px" }}>Show/Hide Sub (1)</Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            border: "dashed 1px",
            p: 0.5,
            justifyContent: "space-between",
            m: 0.5,
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              px: 0.5,
              // backgroundColor: "white",
              // color: "#000000",
              borderRadius: 1,
              mx: 0.5,
              borderStyle: "outset",
              fontSize: "13px",
            }}
          >
            Y
          </Typography>
          <ForwardIcon fontSize="small" />
          <Typography sx={{ fontSize: "13px" }}>Show/Hide Sub (2)</Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            border: "dashed 1px",
            p: 0.5,
            justifyContent: "space-between",
            m: 0.5,
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              px: 0.5,
              // backgroundColor: "white",
              // color: "#000000",
              borderRadius: 1,
              mx: 0.5,
              borderStyle: "outset",
              fontSize: "13px",
            }}
          >
            ]
          </Typography>
          <ForwardIcon fontSize="small" />
          <Typography sx={{ fontSize: "13px" }}>
            Subtitle Delay +100ms (1)
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            border: "dashed 1px",
            p: 0.5,
            justifyContent: "space-between",
            m: 0.5,
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              px: 0.5,
              // backgroundColor: "white",
              // color: "#000000",
              borderRadius: 1,
              mx: 0.5,
              borderStyle: "outset",
              fontSize: "13px",
            }}
          >
            [
          </Typography>
          <ForwardIcon fontSize="small" />
          <Typography sx={{ fontSize: "13px" }}>
            Subtitle Delay -100ms (1)
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            border: "dashed 1px",
            p: 0.5,
            justifyContent: "space-between",
            m: 0.5,
            alignItems: "center",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "row-reverse" }}>
            <Typography
              sx={{
                px: 0.5,
                // backgroundColor: "white",
                // color: "#000000",
                borderRadius: 1,
                mx: 0.5,
                borderStyle: "outset",
                fontSize: "13px",
              }}
            >
              shift
            </Typography>
            <Typography>+</Typography>
            <Typography
              sx={{
                px: 0.5,
                // backgroundColor: "white",
                // color: "#000000",
                borderRadius: 1,
                mx: 0.5,
                borderStyle: "outset",
                fontSize: "13px",
              }}
            >
              ]
            </Typography>
          </Box>
          <ForwardIcon fontSize="small" />

          <Typography sx={{ fontSize: "13px" }}>
            Subtitle Delay +100ms (2)
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            border: "dashed 1px",
            p: 0.5,
            justifyContent: "space-between",
            m: 0.5,
            alignItems: "center",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "row-reverse" }}>
            <Typography
              sx={{
                px: 0.5,
                // backgroundColor: "white",
                // color: "#000000",
                borderRadius: 1,
                mx: 0.5,
                borderStyle: "outset",
                fontSize: "13px",
              }}
            >
              Shift
            </Typography>
            <Typography>+</Typography>
            <Typography
              sx={{
                px: 0.5,
                // backgroundColor: "white",
                // color: "#000000",
                borderRadius: 1,
                mx: 0.5,
                borderStyle: "outset",
                fontSize: "13px",
              }}
            >
              ]
            </Typography>
          </Box>
          <ForwardIcon fontSize="small" />

          <Typography sx={{ fontSize: "13px" }}>
            Subtitle Delay -100ms (2)
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
